<!--section about us-->
<section class="teamrow">
    <div class="container">
        <div class="row">
            <div class="col-md-12 text-center">
                <div class="white_fonts">
                    <div class="row animate__animated animate__fadeInUp top">
                        <div class="col-sm-2"></div>
                        <div class="col-sm-8">
                            <header class="section-header">
                                <h3>Our Team</h3>
                            </header>
                        </div>
                        <div class="col-sm-2"></div>
                    </div>
                </div>
            </div>

        </div>
    </div>
</section>
<!-- end section -->

<!-- ======= Team Section ======= -->

 <!-- ======= Team Section ======= -->
 <section id="team" class="team section-bg">
  <div class="container" data-aos="fade-up">

    <ngx-skeleton-loader count="5" appearance="line" *ngIf="users===undefined"></ngx-skeleton-loader>
    <!-- <ngx-shimmer-loading [appearance]="'line'" [width]="'100%'" [height]="'200px'" *ngIf="users===undefined"></ngx-shimmer-loading> -->

    <div class="row" *ngIf="users!==undefined">

      <div class="col-lg-3 col-xs-12 d-flex align-items-stretch" data-aos="fade-up" data-aos-delay="100" 
      style="display: flex;align-items: center;justify-content: center;" *ngFor="let user of users">
        <div class="member" data-aos="fade-up" data-aos-delay="100">
          <!-- (click)="goToDetailsPage(user.id)" -->
          <div class="member-img">            
            <img [src]="'data:image/png;base64,'+user.avatar"  alt="">
          </div>
          <div class="member-info" style="cursor: pointer;height: 105px;">
            <h4>{{user.name}}</h4>
            <span>{{user.designation}}</span>            
          </div>
          <div class="member-info pt-1 d-flex align-items-end">
            <a href="mailto:{{user.email}}" style="cursor: pointer;font-size: 13px;"><i class="fa fa-envelope-o"></i><label style="margin:5px;font-size: 13px;cursor: pointer;">{{user.email}}</label></a>
          </div>

        </div>
      </div>
    </div>
  </div>
</section><!-- End Team Section -->